import React, { useEffect, useState } from 'react';
import Markdown from 'markdown-to-jsx';
import { sendSitewideBannerEvent } from 'snowplow';

import { TinyParagraph } from 'ggApp/shared/common/Typography';
import CloseSmall from 'ggApp/shared/icons/CloseSmall';
import { getOrderFromCookiesBasedStore as getOrderFromCookies } from 'ggApp/shared/context/Order/cookies';

import { Wrap, CloseButton } from './styled';

export type SitewideBannerProps = {
    sitewideBannerData?: {
        variantKey?: string;
        variantAttachment?: {
            text?: {
                en?: string;
                de?: string;
                nl?: string;
                es?: string;
            };
        };
    };
};

export type EnhancedProps = {
    activeStore: {
        activeLanguage: string;
        store_id: number;
        code: string;
    };
    userId?: number | null;
    initDone?: boolean;
};

export const SitewideBanner = ({
    sitewideBannerData,
    activeStore,
    userId,
    initDone,
}: SitewideBannerProps & EnhancedProps): JSX.Element | null => {
    const [showBanner, setShowBanner] = useState(false);

    const bannerEnabled = sitewideBannerData?.variantKey !== 'disabled';
    const bannerText =
        sitewideBannerData?.variantAttachment?.text?.[activeStore.activeLanguage] ?? '';

    let finalText = bannerText.replace(/<\/?a[^>]*>/g, '');

    if (finalText.length > 99) finalText = `${finalText.substring(0, 97)}...`;

    useEffect(() => {
        setShowBanner(
            localStorage.getItem('showSitewideBanner')
                ? localStorage.getItem('showSitewideBanner') === 'true'
                : true,
        );
    }, []);

    const closeBanner = () => {
        localStorage.setItem('showSitewideBanner', 'false');
        setShowBanner(false);
    };

    const handleBannerClick = () => {
        const orderID = getOrderFromCookies(activeStore.code) ?? null;
        const userID = userId ?? null;
        const eventPayload = {
            eventAction: 'click',
            eventLabel: finalText,
            eventProperty: {
                store: activeStore.store_id,
                orderID,
                userID,
                bannerType: 'siteWideBanner',
            },
        };
        sendSitewideBannerEvent(eventPayload);
    };

    useEffect(() => {
        if (bannerEnabled && bannerText && initDone && showBanner) {
            const orderID = getOrderFromCookies(activeStore.code) ?? null;
            const userID = userId ?? null;
            const eventPayload = {
                eventAction: 'view',
                eventLabel: finalText,
                eventProperty: {
                    store: activeStore.store_id,
                    orderID,
                    userID,
                    bannerType: 'siteWideBanner',
                },
            };
            sendSitewideBannerEvent(eventPayload);
        }
    }, [
        activeStore.code,
        activeStore.store_id,
        bannerEnabled,
        showBanner,
        bannerText,
        initDone,
        finalText,
        userId,
    ]);

    if (bannerEnabled && bannerText) {
        return showBanner ? (
            <Wrap>
                <TinyParagraph>
                    <Markdown onClick={handleBannerClick}>
                        {sitewideBannerData?.variantAttachment?.text?.[activeStore?.activeLanguage]}
                    </Markdown>
                </TinyParagraph>

                <CloseButton onClick={closeBanner}>
                    <CloseSmall />
                </CloseButton>
            </Wrap>
        ) : null;
    }
    return null;
};
